const BBRank = () => {
    return (
        <>
            <nav className="panel mt-3 is-info">
                <p className="panel-heading" style={{ color: "white" }}>
                    Ranking indywidualny Biegu Belfrów
                    <div style={{ fontWeight: "normal" }}>
                        Nowość ! Przejdź, przebiegnij lub przejedź najwięcej kilometrów spośród wszystkich Belfrów. Dołącz do
                        dodatkowej rywalizacji.
                    </div>
                </p>

                {/* <div className="panel-block">
                        <p className="control has-icons-left">
                            <input className="input" type="text" placeholder="Search" />
                            <span className="icon is-left">
                                <i className="fas fa-search" aria-hidden="true"></i>
                            </span>
                        </p>
                    </div> */}
                <p className="panel-tabs">
                    <a className="is-active">Spacer</a>
                    <a>Bieg</a>
                    <a>Rower</a>
                    <a>Iron Teacher</a>
                </p>

                <a className="panel-block is-active">
                    <span className="panel-icon">
                        <i className="fa-solid fa-trophy"></i>
                    </span>
                    <nav className="level" style={{ width: "100%" }}>
                        <div className="level-left">
                            <div className="level-item">
                                Pierwszy uczestnik <small>&nbsp;(Szkoła Podstawowa z miejscowości)</small>
                            </div>
                        </div>
                        <div className="level-right">
                            <div className="level-item">100 km</div>
                        </div>
                    </nav>
                </a>
                <a className="panel-block">
                    <span className="panel-icon">2.</span>
                    <nav className="level" style={{ width: "100%" }}>
                        <div className="level-left">
                            <div className="level-item">
                                Drugi uczestnik <small>&nbsp;(nauczyciel matematyki)</small>
                            </div>
                        </div>
                        <div className="level-right">
                            <div className="level-item">90 km</div>
                        </div>
                    </nav>
                </a>
                <a className="panel-block">
                    <span className="panel-icon">3.</span>
                    <nav className="level" style={{ width: "100%" }}>
                        <div className="level-left">
                            <div className="level-item">Trzeci uczestnik</div>
                        </div>
                        <div className="level-right">
                            <div className="level-item">80 km</div>
                        </div>
                    </nav>
                </a>
                <a className="panel-block">
                    <a>pokaż więcej</a>
                </a>
                <a className="panel-block">
                    <i>zaloguj się, aby zobaczyć swój wynik</i>
                </a>
                {/* <label className="panel-block">
                        <input type="checkbox" />
                        remember me
                    </label> */}
                {/* <div className="panel-block">
                        <button className="button is-link is-outlined is-fullwidth">Reset all filters</button>
                    </div> */}
            </nav>
            {/* <div className="massage">
                    <div className="card">
                        <div className="card-content">
                            <p className="title">Ogólnopolski ranking Biegu Belfrów</p>
                            <p className="subtitle">Wybierz dyscyplinę</p>
                        </div>
                        <footer className="card-footer">
                            <p className="card-footer-item">
                                <a href="">Spacer</a>
                            </p>
                            <p className="card-footer-item">
                                <span>Bieg</span>
                            </p>
                            <p className="card-footer-item">
                                <span>Jazda</span>
                            </p>
                            <p className="card-footer-item">
                                <span>Iron Teacher</span>
                            </p>
                        </footer>
                        <div className="card-content">
                            <div className="list has-visible-pointer-controls has-hidden-images">
                                <div className="list-item">
                                    <div className="list-item-image">
                                        <figure className="image is-64x64">
                                            <img className="is-rounded" src="https://via.placeholder.com/128x128.png?text=Image" />
                                        </figure>
                                    </div>
                                    <div className="list-item-content" style={{ textAlign: "left" }}>
                                        <div className="list-item-title">Anita</div>
                                        <div className="list-item-description">Szkoła Podstawowa w Koszalinie</div>
                                    </div>

                                    <div className="list-item-controls">
                                        <div className="is-left">100 km </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            {/* </div>
                    </div>
                </nav> */}{" "}
        </>
    );
};
export default BBRank;
